import React, { useState } from 'react';
import axios from 'axios';
import { X, FileText, Loader2 } from 'lucide-react';

function DescriptionEditModal({ productId, productTitle, currentDescription, onClose, onDescriptionUpdated }) {
  const [description, setDescription] = useState(currentDescription || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const baseUrl = process.env.REACT_APP_API_URL || '';

  const handleSave = async () => {
    setSaving(true);
    setError('');

    try {
      const { data } = await axios.patch(
        `${baseUrl}/api/products/${productId}`,
        { description: description.trim() }
      );

      onDescriptionUpdated(productId, data.description);
    } catch (error) {
      console.error('Error updating description:', error);
      setError(error.response?.data?.error || 'Error al actualizar la descripción');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-slate-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-brand-primary/10 rounded-xl flex items-center justify-center">
              <FileText className="w-5 h-5 text-brand-primary" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-slate-900 font-montserrat">
                Editar Descripción
              </h2>
              <p className="text-sm text-slate-600 font-montserrat truncate max-w-md">
                {productTitle}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            disabled={saving}
            className="p-2 hover:bg-slate-100 rounded-lg transition-colors disabled:opacity-50"
          >
            <X className="w-5 h-5 text-slate-500" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Escribe una descripción del producto..."
            disabled={saving}
            rows={8}
            className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-brand-primary/20 focus:border-brand-primary text-sm font-montserrat resize-none disabled:opacity-50 disabled:bg-slate-50"
            autoFocus
          />
          <div className="flex items-center justify-between mt-2">
            <p className="text-xs text-slate-500 font-montserrat">
              {description.length} caracteres
            </p>
            {error && (
              <p className="text-sm text-red-600 font-montserrat">{error}</p>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center gap-3 p-6 border-t border-slate-200">
          <button
            onClick={onClose}
            disabled={saving}
            className="flex-1 px-4 py-2.5 border border-slate-300 text-slate-700 rounded-xl font-semibold font-montserrat hover:bg-slate-50 transition-colors disabled:opacity-50"
          >
            Cancelar
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            className="flex-1 px-4 py-2.5 bg-brand-primary text-white rounded-xl font-semibold font-montserrat hover:bg-brand-primary/90 transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {saving ? (
              <>
                <Loader2 className="w-4 h-4 animate-spin" />
                Guardando...
              </>
            ) : (
              'Guardar'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DescriptionEditModal;